/**
 * @fileoverview Predefined categories offered when tracking a purchase.
 * @module lib/domain/categories
 */

/**
 * Closed set of categories offered in the purchase form's dropdown.
 *
 * @description
 * A fixed list keeps the {@link CategoryRow} filter and the statistics
 * breakdown meaningful instead of splintering into one-off free-text
 * spellings ("Vetement", "vêtements", "Vêtement…"). A purchase created before
 * this list existed, or imported from another source, may still carry a
 * category outside it — the form preserves that value as an extra option
 * rather than silently discarding it.
 */
export const PREDEFINED_CATEGORIES: readonly string[] = [
	"Vêtements",
	"Électronique",
	"Maison",
	"Sport & Loisirs",
	"Beauté & Santé",
	"Transport",
	"Cuisine",
	"Autre",
]
